import { render, staticRenderFns } from "./SentFollowupEmails.vue?vue&type=template&id=2b01e120&scoped=true"
import script from "./SentFollowupEmails.vue?vue&type=script&lang=js"
export * from "./SentFollowupEmails.vue?vue&type=script&lang=js"
import style0 from "./SentFollowupEmails.vue?vue&type=style&index=0&id=2b01e120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01e120",
  null
  
)

export default component.exports